import React from 'react';

// Верхняя строка экрана по «Бумаге» (артборд App): одна строка высотой 34px
// прямо на фоне страницы — ни заливки, ни разделителя. Слева путь и заголовок,
// справа слот действий.
//
// 🪤 Подсказки вкладки (`subtitle`) в макете нет: там полоса всегда в одну
// строку. Текст оставлен — он объясняет незнакомому человеку, что делает
// раздел, — но переехал в ту же строку третьим, серым и с усечением. Двумя
// этажами полоса становится вдвое выше макетной и ест высоту у самого экрана.
//
// compact — телефон: остаётся один заголовок. Подсказка не влезает, а кнопка
// обращений справа живёт там же в меню пользователя в шторке.
export default function AppTopbar({ breadcrumb, title, subtitle, right, compact = false, path = null }) {
  return (
    // mb-3 — тот же зазор, что между карточками экрана: без него кнопка справа
    // (высотой во всю строку) прилипала к первой карточке (замечание 24.09.2026).
    <div className="h-[34px] mb-3 shrink-0 px-[6px] flex items-center justify-between gap-4 font-ui">
      {/* path — готовый узел вместо заголовка (путь к записи с меню): без усечения
          по краю, иначе выпадающее меню обрезалось бы. */}
      {path ? (
        <div className="min-w-0 flex items-center text-[13px]">{path}</div>
      ) : (
      <div className="min-w-0 flex items-baseline gap-2 text-[13px] whitespace-nowrap">
        {breadcrumb && <span className="text-paper-ink-3 shrink-0">{breadcrumb}</span>}
        {title && <span className="font-semibold text-paper-ink truncate">{title}</span>}
        {subtitle && !compact && <span className="text-paper-ink-3 truncate">{subtitle}</span>}
      </div>
      )}
      {!compact && <div className="flex items-center gap-[18px] shrink-0 text-[13px] text-paper-ink-2">{right}</div>}
    </div>
  );
}
